/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserInviteAction } from '../../models/user-invite-action';
import { UserInviteActionResponse } from '../../models/user-invite-action-response';

export interface UpdateUserInvite$Params {

/**
 * Id of a user invite.
 */
  id: string;
      body: UserInviteAction
}

export function updateUserInvite(http: HttpClient, rootUrl: string, params: UpdateUserInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInviteActionResponse>> {
  const rb = new RequestBuilder(rootUrl, updateUserInvite.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserInviteActionResponse>;
    })
  );
}

updateUserInvite.PATH = '/api/v1/user_invites/{id}';
